import React from 'react';
import { motion } from 'framer-motion';

const techStack = [
  { name: 'Laravel', short: 'L' },
  { name: 'PHP', short: 'PHP' },
  { name: 'MySQL', short: 'SQL' },
  { name: 'Redis', short: 'R' },
  { name: 'Vue.js', short: 'V' },
  { name: 'Livewire', short: 'LW' },
  { name: 'AWS', short: 'AWS' },
  { name: 'Docker', short: 'D' },
  { name: 'Git', short: 'G' },
];

const TechStack = () => {
  return (
    <section id="tech-stack" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-3">
            Primary Tech Stack
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
            Technologies I use to architect, build, and scale production platforms.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {techStack.map((tech, index) => (
            <motion.div
              key={tech.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
              viewport={{ once: true }}
              whileHover={{ y: -4, scale: 1.03 }}
              className="bg-white border border-gray-200 rounded-xl p-4 md:p-5 shadow-md hover:-translate-y-2 transition-all duration-300"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-blue-600/10 text-blue-700 font-bold text-sm flex items-center justify-center">
                  {tech.short}
                </div>
                <div className="text-gray-900 font-semibold text-sm md:text-base">
                  {tech.name}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
